$(document).ready(function () {
    $('.ttm-header-icons .ttm-header-login > a').hover(function () {
        $(this).siblings('.dropdown-menu').css('opacity', 1);
    });
    $('.ttm-header-icons .ttm-header-login').mouseleave(function () {
        $(this).find('.dropdown-menu').css('opacity', 0);
    });

    addCommas = function(x) {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }

    // Add comma to numbers every 3 digits
    $.fn.digits = function(){
        return this.each(function(){
            $(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") );
        })
    }

    /* ==========plugin upload picture proflie */
    const readURL = function(input) {
        if (input.files && input.files[0]) {
            let inputImage = $(input).attr('data-image');
            if(input.files[0].size > 2000000) {
                if(inputImage === 'color'){
                    $('label[for=customFile]').text('حداکثر 2 مگابایت').css('color', 'red');
                }else{
                    $('label[for=orderImage] span').css('display', 'block');
                    $('.profile-pic1').attr('src', '');
                    $('.orderImageText').text('حداکثر 2 مگابایت').css('color', 'red');
                }
                input.value = "";
            }else{
                var reader = new FileReader();
                reader.onload = function (e) {
                    let inputImage = $(input).attr('data-image');
                    if(inputImage === 'color'){
                        $('.profile-pic').attr('src', e.target.result);
                        $('.upload-button').css('color', 'transparent');
                    }else{
                        $('label[for=orderImage] span').css('display', 'none');
                        $('.profile-pic1').attr('src', e.target.result);
                    }
                }
                reader.readAsDataURL(input.files[0]);
            }
        }
    }

    $(".file-upload").on('change', function(){
        readURL(this);
    });

    $(".upload-button").on('click', function() {
        $(".file-upload").click();
    });
    /* ==========plugin upload picture proflie */
})
